import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { mapActions } from "vuex";
import { UPLOAD_DOCUMENT_TO_CLASSIFICATION } from "../store/document-actions";
import DocumentRow from "./document-listing/document-row";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentClassificationBody",
  components: {
    DocumentRow,
    SimpleButton
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    documents: {
      type: Object,
      required: true
    },
    classification: {
      type: Object,
      required: true
    },
    comments: {
      type: Object,
      required: true
    },
    completed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uploadingDocuments: false
    };
  },
  computed: {
    noDocuments() {
      return isEmpty(this.documents.byId);
    },
    classificationDescription() {
      return this.classification.description;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DocumentStore", [UPLOAD_DOCUMENT_TO_CLASSIFICATION])), {}, {
    getCommentsForDocument(documentId) {
      var _context;
      return _reduceInstanceProperty(_context = this.documents.byId[documentId].comments).call(_context, (acc, commentId) => {
        acc.byId[commentId] = this.comments.byId[commentId];
        return acc;
      }, {
        byId: {}
      });
    },
    async handleFilesSelected(event) {
      const files = event.target.files;
      if (!(files != null && files.length)) return;
      this.uploadingDocuments = true;
      await this.UPLOAD_DOCUMENT_TO_CLASSIFICATION({
        applicationId: this.applicationId,
        classification: this.classification,
        files
      });
      this.$refs.fileInput.value = "";
      this.uploadingDocuments = false;
    }
  })
});